module.exports = __webpack_public_path__ + "static/media/techArch.e4001d69.png";